// extracted by mini-css-extract-plugin
export default {"canvas":"Canvas_canvas__P7a3y"};